package com.banyan.flightviewer.web.components.map

/**
 * Altitude → hex color. Shared by the marker renderer, the tooltip
 * formatter, and the selected-flight polyline so every visual cue agrees
 * on what "high" or "low" looks like.
 *
 * Mirrors [map.html altitudeColor()](desktop/src/main/resources/leaflet/map.html) lines 249-257.
 */
fun altitudeColor(alt: Double): String = when {
    // Ground + unknown: dark gray. Medium #888888 got lost against the
    // light concrete of runways on satellite / hybrid tiles; #2E2E2E
    // reads as distinctly "an aircraft on the ground" on every basemap
    // (still visible against the dark CartoDB tiles because the marker
    // silhouettes aren't pure black).
    alt <= 0 -> "#2E2E2E"
    alt < 5_000 -> "#00C853"
    alt < 15_000 -> "#FFD600"
    alt < 25_000 -> "#FF9100"
    alt < 35_000 -> "#FF6D00"
    else -> "#AA00FF"
}

/** Convenience overload for the `String` altitude used on [com.banyan.flightviewer.state.AircraftData]. */
fun altitudeColor(altitude: String): String {
    val alt = altitude.toDoubleOrNull() ?: return "#2E2E2E"
    return altitudeColor(alt)
}
